import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { NgxSmartModalModule } from 'ngx-smart-modal';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';


import { adminLteConf } from './admin-lte.conf';
import { AppRoutingModule } from './app-routing.module';
import { CoreModule } from './core/core.module';
import { LayoutModule } from 'angular-admin-lte';
import { ChartsModule } from 'ng2-charts';
import { PapaParseModule } from 'ngx-papaparse';
import { AngularEditorModule } from '@kolkov/angular-editor';

import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { ProfileComponent } from './profile/profile.component';
import { LoaderComponent } from './loader/loader.component';
import { DashboardComponent } from './dashboard/dashboard.component';

import { LoadingPageModule, MaterialBarModule } from 'angular-loading-page';
import { AuthenticationService,DashboardService,ProfileService, SurveyService,EmployeesService,CompanyService,FormService } from './_services/index';
import { CookieService } from 'ngx-cookie-service';
import { LoaderService } from './_services/loader.service';
import { AlertService } from './_services/alert.service';

import { HttpClientModule, HTTP_INTERCEPTORS,HttpClient } from '@angular/common/http';
import { AuthInterceptor} from './interceptor/authinterceptor';
import { LoaderInterceptor } from './interceptor/loader.interceptor';

import { PagerService } from './_services/index';
import { UsersComponent } from './users/users.component';
import { BusinessComponent } from './business/business.component';
import { CompanyComponent } from './business/company/company.component';
import { FormsComponent } from './forms/forms.component';
import { FormComponent } from './forms/form/form.component';
import { EmployeesComponent } from './employees/employees.component';
import { EmployeeComponent } from './employees/employee/employee.component';
import { SurveyComponent } from './survey/survey.component';
import { SurveyListComponent } from './surveyList/surveyList.component';
import { SurveyEmployeeComponent } from './surveyList/surveyEmployee/surveyEmployee.component';
@NgModule({
  imports: [
    BrowserModule,
    AppRoutingModule,
    CoreModule,
    LayoutModule.forRoot(adminLteConf),
    NgxSmartModalModule.forRoot(),
    LoadingPageModule,
    MaterialBarModule,
    FormsModule,
    ReactiveFormsModule,
    CarouselModule,
    BrowserAnimationsModule,
    ChartsModule,
    PapaParseModule,
    AngularEditorModule,
  ],
  providers: [
    CookieService,
    AuthenticationService,
    ProfileService,
    CompanyService,
    LoaderService,
    EmployeesService,
    AlertService,
    SurveyService,
    DashboardService,
    FormService,
    { provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
    { provide: HTTP_INTERCEPTORS, useClass: LoaderInterceptor, multi: true },
    PagerService
  ],
  declarations: [
    AppComponent,
    HomeComponent,
    ProfileComponent,
    LoaderComponent,
    DashboardComponent,
    UsersComponent,
    BusinessComponent,
    CompanyComponent,
    FormsComponent,
    FormComponent,
    EmployeesComponent,
    EmployeeComponent,
    SurveyListComponent,
    SurveyComponent,
    SurveyEmployeeComponent
  ],
  bootstrap: [AppComponent]
})
export class AppModule {}
